export const TREASURY_ACCOUNT_ID = "0000000000"
export const GRPC_BALANCE_FACTOR = 100000000
export const LANDING_PAGE = '/users'
export const EXCEL_DOC_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'